import type { IncludedFees } from "@app/helpers/price";
import type { CartPollResponse } from "@app/modules/checkout/types/cart-v2";
import type { TripType } from "@app/modules/results/constants/departure-types";
import type { NapiClient } from "@app/services/api";
import { getApiBrowser } from "@app/services/api-factory";
import type { SearchInfo } from "@app/types/search-types";
import type { PassengerSeatSelectionInstance } from "@app/types/seat-selection-types";

import type { MaybePartner } from "@partners/partner.type";
import type Bluebird from "bluebird";

export abstract class CartBase {
  protected api: NapiClient;
  protected cart: CartPollResponse | null = null;
  protected search: SearchInfo;
  protected whitelabel?: MaybePartner;

  public constructor(search: SearchInfo, whitelabel?: MaybePartner) {
    // @ts-expect-error
    this.api = getApiBrowser();
    this.search = search;
    this.whitelabel = whitelabel;
  }

  public abstract get departure_type(): TripType;

  public abstract reserve(
    departure_or_trip_id: string,
    billing_country?: string,
    passengers?: PassengerSeatSelectionInstance[]
  ): Promise<void> | Bluebird<void>;

  public abstract isSamePriceAsBefore(
    selected_price: number,
    options?: IsSamePriceAsBeforeOptions
  ): boolean;

  public getCart() {
    return this.cart;
  }
}

export type IsSamePriceAsBeforeOptions = { include_fees?: IncludedFees };
